import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What are API integration services, and how can they benefit my business?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>API (Application Programming Interface) integration services involve integrating different software systems and applications through APIs. API integration services can benefit businesses that rely on multiple software systems to manage their operations. It allows businesses to streamline their operations, improve efficiency, and increase the functionality of their systems by enabling them to communicate and share data.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What types of systems and applications can be integrated through API integration services?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>API integration services can integrate multiple systems and applications, including CRM systems, ecommerce platforms, marketing automation tools, and social media platforms. The integrated systems depend on the needs of the business and the capabilities of the APIs being used.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    How does TekRevol differ from other API integration service providers?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>At TekRevol, we pride ourselves on our customer-centric approach and commitment to delivering high-quality results. Our team of experienced software developers has a wealth of expertise in API integration, and we are proficient in modern programming languages and frameworks. We work closely with our clients to understand their unique business needs and goals and create custom API integration solutions tailored to their specific requirements. We also offer a range of pricing options to fit different budgets and needs, and we are always available to provide ongoing support and maintenance as needed.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;